import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'pre-approval-tag-renderer',
    templateUrl: './pre-approval-tag-renderer.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class PreApprovalTagRendererComponent implements ICellRendererAngularComp {
  name: string = "";
  preApprovalId: number = 0;
  preapprovalTag: any;
  //delete after testing
  preApprovalTag = {remainingDays: 2, approvalDate: "2024-06-30T00:00:00", balance: 100, currencyCode: 35, overDue: 4};

  constructor() { }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

  initilize(params: ICellRendererParams) {
    this.name =  params.getValue();
    if (params.data && params.data.preApprovalId) {
      this.preApprovalId = params.data.preApprovalId;
    }
    if (params.data && params.data.preApprovalId) {
       this.preApprovalTag = params.data.preApprovalTag;
    }
      this.name = "name Approved";
      this.preApprovalId = 1;
      this.preApprovalTag.remainingDays = 2;
      this.preApprovalTag.approvalDate = "2024-06-30T00:00:00";
      this.preApprovalTag.balance = 100;
      this.preApprovalTag.currencyCode = 35;
      this.preApprovalTag.overDue = 4;
  }
}
